const CategoryConstants = {
	kitchen: 'Kjøkken',
	bathroom: 'Baderom',
	laundry: 'Vaskerom',
	wardrobe: 'Garderobe',
	project_main: 'Hovedprosjekt'
};

export default CategoryConstants;
